import script from "./CardDatosFiscales.vue?vue&type=script&setup=true&lang=js"
export * from "./CardDatosFiscales.vue?vue&type=script&setup=true&lang=js"

import "./CardDatosFiscales.vue?vue&type=style&index=0&id=771cca95&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-771cca95"]])

export default __exports__